module.exports = __webpack_public_path__ + "img/report-12.499e14bd.jpg";